module.exports = __webpack_public_path__ + "static/media/barber1.1cbe41b1.jpg";